import { ObservableArray, View, ViewModel } from "binder"
import { FormBuilderComponentView } from "src/formBuilder/structure/element";
import { ITemplateSelector } from "src/uicomponents/components/templateSelector";
import { getAsBoolean } from "src/uicomponents/components/utilities";
import { ColumnViewModel, ServerSideDataLoader } from "uicomponents";
import { ServerFilteringTableViewModel } from "./serverFilteringTable-viewModel"

export class ServerFilteringTableView extends FormBuilderComponentView<ServerFilteringTableViewModel>{
    GetViewUniqueId(): string {
        return "V-131CC6D2-3BFB-449C-BAEF-C9EF15E20B99"
    }
    loadHtml(): string {
        let element = require('./serverFilteringTable.html').default;
        let style = require('./serverFilteringTable.less');
        return element;
    }
    constructor() {
       super();
    }
    public set ItemsSource(v: ObservableArray<ViewModel>) { this._ItemsSource = v; } public get ItemsSource(): ObservableArray<ViewModel> { return this._ItemsSource;} private _ItemsSource: ObservableArray<ViewModel>;
    public set TemplateSelector(v: ITemplateSelector) { this._TemplateSelector = v; } public get TemplateSelector(): ITemplateSelector { return this._TemplateSelector;} private _TemplateSelector: ITemplateSelector;
    public set ItemTemplateSelector(v: string) { this._ItemTemplateSelector = v; } public get ItemTemplateSelector(): string { return this._ItemTemplateSelector;} private _ItemTemplateSelector: string;
    public set ShowingColumns(v: ObservableArray<ColumnViewModel>) { this._ShowingColumns = v; } public get ShowingColumns(): ObservableArray<ColumnViewModel> { return this._ShowingColumns;} private _ShowingColumns: ObservableArray<ColumnViewModel>;
    public set UseElastics(v: boolean) { this._UseElastics = getAsBoolean(v); } public get UseElastics(): boolean { return this._UseElastics;} private _UseElastics: boolean;
    public set Loader(v: ServerSideDataLoader) { this._Loader = v; } public get Loader(): ServerSideDataLoader { return this._Loader;} private _Loader: ServerSideDataLoader;
    public set StickyHeaders(v: boolean) { this._StickyHeaders = getAsBoolean(v); } public get StickyHeaders(): boolean { return this._StickyHeaders;} private _StickyHeaders: boolean;
    
}
